module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/mv-0b82fad41808cd42ef8f9576474d344d.png";